/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminBenutzerverwaltungControllerGetProfilbildV1$Params {
  id: string;
}

export function adminBenutzerverwaltungControllerGetProfilbildV1(http: HttpClient, rootUrl: string, params: AdminBenutzerverwaltungControllerGetProfilbildV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, adminBenutzerverwaltungControllerGetProfilbildV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/webp', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

adminBenutzerverwaltungControllerGetProfilbildV1.PATH = '/v1/benutzerverwaltung/{id}/profilbild';
